import ChatApi from "../../apis/chatApi";
import { triggerBlobDownload } from "../../utils/downloadUtils";

export { triggerBlobDownload };

export function parseCsvExportSearchParams(searchParams: URLSearchParams): { exportId: string; filename: string } | null {
  const exportId = String(searchParams.get("export_id") ?? "").trim().toLowerCase();
  if (!/^[a-f0-9]{40}$/.test(exportId)) return null;
  const filename =
    String(searchParams.get("filename") ?? "theo-export.csv")
      .trim()
      .replace(/[^\w.\- ]+/g, "-") || "theo-export.csv";
  return {
    exportId,
    filename: filename.toLowerCase().endsWith(".csv") ? filename : `${filename}.csv`,
  };
}

export async function downloadThreadCsvExport(
  threadId: string,
  exportId: string,
  filename: string
): Promise<void> {
  const api = new ChatApi();
  const blob = await api.downloadThreadCsvExport(threadId, exportId);
  triggerBlobDownload(blob, filename);
}

export function isCsvExportHref(href: string): boolean {
  try {
    const url = new URL(href, window.location.origin);
    return url.pathname.replace(/\/+$/, "").endsWith("/csv-export");
  } catch {
    return false;
  }
}

export function parsePdfExportSearchParams(searchParams: URLSearchParams): { exportId: string; filename: string } | null {
  const exportId = String(searchParams.get("export_id") ?? "").trim().toLowerCase();
  if (!/^[a-f0-9]{40}$/.test(exportId)) return null;
  const filename =
    String(searchParams.get("filename") ?? "theo-document.pdf")
      .trim()
      .replace(/[^\w.\- ]+/g, "-") || "theo-document.pdf";
  return {
    exportId,
    filename: filename.toLowerCase().endsWith(".pdf") ? filename : `${filename}.pdf`,
  };
}

export async function downloadThreadPdfExport(
  threadId: string,
  exportId: string,
  filename: string
): Promise<void> {
  const api = new ChatApi();
  const blob = await api.downloadThreadPdfExport(threadId, exportId, filename);
  triggerBlobDownload(blob, filename);
}

export function isPdfExportHref(href: string): boolean {
  try {
    const url = new URL(href, window.location.origin);
    return url.pathname.replace(/\/+$/, "").endsWith("/pdf-export");
  } catch {
    return false;
  }
}
